/**
 * Reusable "Download CSV" button — calls into csvExport.js with the
 * already-filtered rows on the host page.
 */
import React from "react";
import { Download } from "lucide-react";
import { exportRowsToCsv } from "@/lib/csvExport";

export default function CsvExportButton({
  rows,
  columns,
  filename,
  label = "CSV",
  disabled,
  testId = "csv-export-button",
  className = "",
}) {
  const handleClick = () => {
    exportRowsToCsv(rows || [], columns, filename || "export.csv");
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || !rows || rows.length === 0}
      data-testid={testId}
      title={`Download ${rows?.length || 0} row${rows?.length === 1 ? "" : "s"} as CSV`}
      className={
        "inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md text-meta font-semibold border border-border-subtle bg-white text-ink-secondary hover:bg-inset hover:text-ink-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors " +
        className
      }
    >
      <Download size={12} />
      {label}
    </button>
  );
}
